// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__1swkb","colCheckbox":"styles_colCheckbox__1lIUB"};